import React from 'react';
import styled from 'styled-components';

interface ILegalIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<ILegalIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Legal = ({ user = 'landlord' }: ILegalIconProps): JSX.Element => (
  <StyledSvg
    user={user}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <path
      d="M9.202 13.62a.782.782 0 10-1.105 1.107.782.782 0 001.105-1.106zM19.781 34.978a2.737 2.737 0 00-2.204-4.354H4.298c-.731 0-1.418.285-1.934.8a2.716 2.716 0 00-.8 1.934c0 .606.198 1.166.532 1.62A3.91 3.91 0 000 38.435v.782c0 .431.35.78.781.78h20.312c.431 0 .781-.349.781-.78v-.782c0-1.5-.85-2.803-2.093-3.458zM3.468 32.53c.221-.22.516-.343.829-.343h13.28a1.173 1.173 0 01.83 2.001 1.164 1.164 0 01-.83.343H4.298a1.173 1.173 0 01-.829-2zm-1.906 5.907a2.346 2.346 0 012.344-2.343H17.968a2.346 2.346 0 012.344 2.343H1.562z"
      fill="#000"
    />
    <path
      d="M39.272 32.822a4.924 4.924 0 00-.94-1.08l-3.651-3.184a.79.79 0 00-.311-.271l-2.208-1.926-10.218-8.913c.419-.437.649-1.01.649-1.617a2.329 2.329 0 00-1.335-2.114l.946-.946a3.115 3.115 0 003.017-.807c.59-.59.915-1.375.915-2.21s-.325-1.62-.916-2.21L18.592.916A3.105 3.105 0 0016.382 0a3.125 3.125 0 00-3.017 3.932l-9.432 9.432a3.144 3.144 0 00-.809-.106c-.835 0-1.62.325-2.21.915a3.129 3.129 0 000 4.42l6.63 6.628c.609.61 1.409.914 2.21.914.8 0 1.6-.305 2.21-.914a3.126 3.126 0 00.807-3.017l.943-.943c.113.237.267.455.458.646a2.328 2.328 0 001.658.687c.607 0 1.179-.23 1.617-.648L28.33 34.45a.784.784 0 00.15.172l3.242 3.726a4.646 4.646 0 004.216 1.606c1.472-.203 2.743-1.083 3.488-2.414a4.623 4.623 0 00-.154-4.718zM15.277 2.02a1.552 1.552 0 011.105-.457c.417 0 .81.162 1.105.457l6.629 6.63c.295.294.457.687.457 1.104a1.564 1.564 0 01-2.667 1.105L15.279 4.23c-.61-.61-.61-1.6 0-2.21zm-4.419 22.096c-.609.61-1.6.61-2.21 0L2.02 17.488a1.564 1.564 0 011.104-2.667c.418 0 .81.162 1.104.456l6.63 6.63c.61.61.61 1.6 0 2.21zm3.29-5.498l-2.185 2.184-6.63-6.629 8.84-8.839 6.629 6.63-2.189 2.188a1.308 1.308 0 00-.021.021l-4.418 4.417-.026.028zm2.789 1.63l-.005.004-.55.55a.776.776 0 01-.552.23.776.776 0 01-.553-.23.777.777 0 01-.01-1.095l4.438-4.437a.784.784 0 011.097.008.777.777 0 01.229.553.774.774 0 01-.23.552l-.546.547a.591.591 0 00-.012.011l-3.306 3.307zm1.618.591l2.283-2.283 9.667 8.433-3.527 3.527-8.423-9.676zm9.451 10.859l3.68-3.68 1.18 1.03-3.832 3.831-1.028-1.181zm10.057 5.078c-.504.9-1.356 1.495-2.339 1.63a3.104 3.104 0 01-2.82-1.08l-2.842-3.265 3.984-3.984 3.262 2.845.007.007c.244.207.461.456.645.741.59.913.632 2.161.103 3.106z"
      fill="#000"
    />
    <path
      d="M14.726 8.097a.781.781 0 00-1.105 0l-3.315 3.314a.781.781 0 101.105 1.105l3.315-3.315a.781.781 0 000-1.104z"
      fill="#000"
    />
  </StyledSvg>
);

export default Legal;
